<template>
	<router-view/>
</template>

<script>
export default {
	name: 'Admin.vue'
}
</script>

<style scoped>

</style>
